import { useIntl } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MenuIcon from '@mui/icons-material/Menu';
import { useMediaQuery, useTheme } from '@mui/material';
import { useDrawerMenu } from '~/containers/DrawerMenu/DrawerMenuContext';
import messages from './messages';

const DrawerButton = () => {
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { showDrawerMenu } = useDrawerMenu();
  return isMobile ? (
    <Tooltip title={intl.formatMessage(messages.openMenu)}>
      <IconButton
        data-test="drawer-button"
        data-testid="drawer-button"
        onClick={() => showDrawerMenu()}
        color="inherit"
        aria-label={intl.formatMessage(messages.openMenu)}
        size="large"
      >
        <MenuIcon />
      </IconButton>
    </Tooltip>
  ) : null;
};

DrawerButton.displayName = 'DrawerButton';

export default DrawerButton;
